// src/components/financeiro/ValorCausa.jsx
import { useState } from "react";

export default function ValorCausa({ onSalvar, onClose }) {
  const [valorCausa, setValorCausa] = useState("");

  const formatarMoeda = (valor) => {
    const numero = valor.replace(/\D/g, "");

    if (!numero) return "";

    return (Number(numero) / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const converterParaNumero = (valor) => {
    return Number(
      valor
        .replace("R$", "")
        .replace(/\./g, "")
        .replace(",", ".")
        .trim()
    );
  };

  const handleSubmit = () => {
    if (!valorCausa) return;

    const valorNumerico = converterParaNumero(valorCausa);

    onSalvar(valorNumerico);
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: 20,
          borderRadius: 8,
          minWidth: 350,
        }}
      >
        <h3>Lançar Valor da Causa</h3>

        <input
          type="text"
          placeholder="Informe o valor da causa"
          value={valorCausa}
          onChange={(e) =>
            setValorCausa(formatarMoeda(e.target.value))
          }
          style={{
            width: "100%",
            padding: 8,
            marginTop: 10,
          }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            marginTop: 20,
          }}
        >
          <button onClick={onClose}>
            Cancelar
          </button>

          <button onClick={handleSubmit}>
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
}